import { type FieldValues } from 'react-hook-form'
import { type SortModelItem } from 'ag-grid-community'

import { type IAirframePreview, type IBaseResponse, type IUser } from 'platform-core'
import { CoreUserService } from 'platform-core/ui'
import {
  type IGetUserResponse,
  type CreateUserParams,
  type CreateUserResponse,
  type ValidResponse,
  type IGetUserStatusResponse
} from '@/models'
import { submitRequest } from '@/util'

export class UserService extends CoreUserService {
  constructor () {
    super(submitRequest)
  }

  async getStatus (sortModel: SortModelItem[] = []): Promise<IAirframePreview[]> {
    let response: IGetUserStatusResponse
    try {
      response = await CoreUserService.submitRequest<IGetUserStatusResponse>(
        'get',
        'v1/user/status',
        undefined,
        { sort: JSON.stringify(sortModel) }
      )
    } catch (e: any) {
      throw new Error(e.message)
    }
    return response.status.airframes
  }

  async updateProfile (userId: string, payload: FieldValues): Promise<IBaseResponse> {
    let response: IBaseResponse
    try {
      response = await CoreUserService.submitRequest<IBaseResponse>(
        'post',
        `v1/user/${userId}`,
        {
          name: payload.name,
          companyName: payload.companyName,
          phoneNumber: payload.phoneNumberRaw,
          notifications: {
            newsletter: payload.notificationsNewsletter,
            'task-reminders': payload.notificationsTaskReminders
          }
        }
      )
    } catch (e: any) {
      throw new Error(e.message)
    }
    return response
  }

  async sendResetEmail (userId: string): Promise<IBaseResponse> {
    let response: IBaseResponse
    try {
      response = await CoreUserService.submitRequest<IBaseResponse>(
        'put',
        `v1/user/${userId}/password/reset`
      )
    } catch (e: any) {
      throw new Error(e.message)
    }
    return response
  }

  async getUserProfile (userId: string): Promise<IUser> {
    let response: IGetUserResponse
    try {
      response = await submitRequest<IGetUserResponse>(
        'get',
        `v1/user/${userId}`
      )
    } catch (e: any) {
      throw new Error(e)
    }
    return response.user
  }

  // TODO: Old, check / remove / update
  async checkEmail (email: string): Promise<boolean> {
    let response: ValidResponse
    try {
      response = await submitRequest<ValidResponse>(
        'post',
        'v1/user/email',
        { email }
      )
    } catch (e: any) {
      throw new Error(e)
    }
    if (!response.success) {
      throw new Error(response.message)
    }
    return response.valid
  }

  async createUser (params: CreateUserParams): Promise<CreateUserResponse> {
    let response: CreateUserResponse
    try {
      response = await submitRequest<CreateUserResponse>(
        'post',
        'v1/user',
        params
      )
    } catch (e: any) {
      throw new Error(e)
    }
    if (!response.success) {
      throw new Error(response.message)
    }
    return response
  }
}
